import { useRoomOrganization } from "./useRoomOrganization";

export type RoomOrganizationKey =
  "none" | "pierreFabre" | "takeda" | "vifor" | "chiesi";

export function useRoomOrganizationKey(
  roomId: string | null
): RoomOrganizationKey {
  const { isPierreFabreRoom, isTakedaRoom, isViforRoom, isChiesiRoom } =
    useRoomOrganization(roomId);

  if (isPierreFabreRoom) return "pierreFabre";
  if (isTakedaRoom) return "takeda";
  if (isViforRoom) return "vifor";
  if (isChiesiRoom) return "chiesi";
  return "none";
}
